<main>
  <router-outlet></router-outlet>
</main>
<notifier-container></notifier-container>

<app-creditor-footer *ngIf="showFooter()" [hide-footer-menu]="hideFooterMenu()"></app-creditor-footer>

<ngx-spinner type="ball-spin"></ngx-spinner>